import { render, staticRenderFns } from "./stok_darah.vue?vue&type=template&id=5818af4d&scoped=true"
import script from "./stok_darah.vue?vue&type=script&lang=js"
export * from "./stok_darah.vue?vue&type=script&lang=js"
import style0 from "./stok_darah.vue?vue&type=style&index=0&id=5818af4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818af4d",
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator})
